import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Application, Environment, Locale } from "./types";

const theme = createTheme({
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("performanceCalculatorReact") as HTMLElement,
);

function mapStringToEnvironment(env: string | undefined): Environment {
  switch (env) {
    case "local":
      console.info("Current environment", env);
      return Environment.LOCAL;
    case "dev":
      console.info("Current environment", env);
      return Environment.DEV;
    case "uat":
      console.info("Current environment", env);
      return Environment.UAT;
    case "prod":
    default:
      return Environment.PROD;
  }
}

function mapStringToApplication(app: string | undefined): Application {
  switch (app) {
    case "abuOnline":
      return Application.ABU_ONLINE;
    case "ersteRealEstate":
      return Application.ERSTE_REAL_ESTATE;
    case "blueprint":
    case "eamsk":
    default:
      return Application.DEFAULT;
  }
}

function mapStringToLocale(locale: string | undefined): Locale {
  switch (locale) {
    case "deAT":
      return Locale.deAT;
    case "enAT":
      return Locale.enAT;
    case "deDE":
      return Locale.deDE;
    case "enDE":
      return Locale.enDE;
    case "skSK":
      return Locale.skSK;
    case "enSK":
      return Locale.enSK;
    default:
      return Locale.enDE;
  }
}

root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <App
        locale={mapStringToLocale(process.env.REACT_APP_LOCALE)}
        environment={mapStringToEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        application={mapStringToApplication(process.env.REACT_APP_APPLICATION)}
      />
    </React.StrictMode>
  </ThemeProvider>,
);
